export const modules = [
  {label: "Reputation", value: "reputation", short_name: 'Reputation'},
  {label: "GeoIP", value: "geoip", short_name: 'GeoIP'},
  {label: "Whois", value: "whois", short_name: 'Whois'},
  {label: "Is Known Endpoint", value: "is_known_endpoint", short_name: 'Is Known Endpoint'},
  {label: "Is IP in Network", value: "is_ip_in_network", short_name: 'Is IP in Network'},
  {label: "Anomalous Country Login Learned Behavior", value: "acl", short_name: 'ACL'},
  {label: "SLD ML Model Learned Behavior", value: "sld", short_name: 'SLD'},
  {label: "Travel Notifications", value: "travel_notifications", short_name: 'Travel Notifications'},
  {label: "Related Cases", value: "related_cases", short_name: 'Related Cases'},
  {label: "Sixth Sense Links", value: "links", short_name: 'Links'},
  {label: "Logins", value: "logins", short_name: 'Logins'},
];

export const startPoints = [
  {
    label: "IP Investigation",
    values: [
      "geoip",
      "reputation",
      "whois",
      "is_known_endpoint",
      "is_ip_in_network",
    ],
    inputLabel: "Enter an IP Address",
    inputValue: "ip",
    agent: "ip",
    expectedFiles: 3 // Modules, summary, traceID
  },
  {
    label: "O365 User Investigation",
    values: [
      "acl",
      "sld",
      "travel_notifications",
      "related_cases",
      "links",
      "logins",
    ],
    inputLabel: "Enter a user ID",
    inputValue: "user_id",
    agent: "o365_user",
    expectedFiles: 4 // Modules, summary, timeline, traceID
  },
];

export const disclaimer = "Note: This feature is currently experimental. Dates and times may be inaccurate, and some data may be incomplete. Please verify all information before sharing it with customers."
